module.exports = __webpack_public_path__ + "static/img/CL.eab57178.png";